import { Stack, MenuItem, FormControlLabel } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '~/app/hooks'
import { BpRadio, EFRadios } from '~/components'
import { ALL_NS } from '~/i18n/namespaces'
import { changeTheme, themeState } from '~/redux/features'

export function SwitchThemeForm() {
  const { t } = useTranslation(ALL_NS)
  const theme = useAppSelector(themeState)
  const dispatch = useDispatch()
  function onChange(_event: any, value: any) {
    dispatch(changeTheme(value))
  }
  return (
    <Stack>
      <EFRadios
        value={theme}
        onChange={onChange}
      >
        <MenuItem sx={{ py: 0.3 }}>
          <FormControlLabel
            value={'light'}
            control={<BpRadio sx={{ pr: 0.5 }} />}
            label={t('Label_LightTheme')}
          />
        </MenuItem>
        <MenuItem sx={{ py: 0.3 }}>
          <FormControlLabel
            value={'dark'}
            control={<BpRadio sx={{ pr: 0.5 }} />}
            label={t('Label_DarkTheme')}
          />
        </MenuItem>
        <MenuItem sx={{ py: 0.3 }}>
          <FormControlLabel
            value={'system'}
            control={<BpRadio sx={{ pr: 0.5 }} />}
            label={t('Label_SystemTheme')}
          />
        </MenuItem>
      </EFRadios>
    </Stack>
  )
}
